import Nav from "./Nav";

export default function LayoutWithNav({ children }) {
  return (
    <div className="flex-1">
      <Nav />
      <div className="px-3 sm:px-4">
        <div className="max-w-screen-lg mx-auto pb-10">{children}</div>
      </div>
    </div>
  );
}
